import script from "./HomeWhy.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeWhy.vue?vue&type=script&setup=true&lang=js"

import "./HomeWhy.vue?vue&type=style&index=0&id=d8f1517a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8f1517a"]])

export default __exports__